import { Reducer } from 'redux';
import ActionAssTypes from '../assessments/types';
import ActionTypesUser from '../user/types';
import ActionTypes, { TCatState } from './types';

export const initialState: TCatState = {
  data: null,
  loading: true,
  errors: undefined,
};

const reducer: Reducer<TCatState> = (
  state = initialState,
  action
): TCatState => {
  switch (action.type) {
    case ActionTypes.DELETE_R:
    case ActionAssTypes.CREATE_R:
    case ActionAssTypes.EDIT_R:
    case ActionTypes.CREATE_R:
    case ActionTypes.GET_ALL_R:
    case ActionTypes.EDIT_R:
      return {
        ...state,
        loading: true,
        errors: undefined,
        data: state.data ? [...state.data] : [],
      };

    case ActionTypes.DELETE_S:
    case ActionAssTypes.EDIT_S:
    case ActionAssTypes.DELETE_S:
    case ActionAssTypes.ARCHIVE_S:
    case ActionAssTypes.CREATE_S:
    case ActionTypes.GET_ALL_S:
    case ActionTypes.EDIT_S:
      return { ...state, loading: false, data: action.payload };

    case ActionTypes.CREATE_S:
      return {
        ...state,
        loading: false,
        data: state.data ? [action.payload, ...state.data] : [action.payload],
      };
    case ActionTypesUser.LOG_OUT_S:
      return {
        data: null,
        loading: true,
        errors: undefined,
      };
    case ActionAssTypes.EDIT_E:
    case ActionAssTypes.CREATE_E:
    case ActionAssTypes.DELETE_E:
    case ActionAssTypes.ARCHIVE_E:
    case ActionTypes.CREATE_E:
    case ActionTypes.DELETE_E:
    case ActionTypes.EDIT_E:
    case ActionTypes.GET_ALL_E:
      return { ...state, loading: false, errors: action.payload };
    default:
      return state;
  }
};

export { reducer as CatsReducer };
